import React, { FC, Fragment } from 'react';
import './RadioInputQuestion.css';

export interface RadioInputQuestionProps {
  question: string;
  answers: RadioInputAnswerOption[];
  errorMessage?: string;
  showError?: boolean;
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue: string;
}

export interface RadioInputAnswerOption {
  answerValue: string;
  inputName: string;
  radioBtnGroupName: string;
}

export const RadioInputQuestion: FC<RadioInputQuestionProps> = ({
  question,
  answers,
  onChangeHandler,
  errorMessage,
  showError = false,
  defaultValue,
}) => {
  return (
    <div className="radio-input-question-container">
      <p className="radio-question-p">{question}</p>
      {showError && <p className="radio-question-error-p">{errorMessage}</p>}
      {answers.map(({ answerValue, inputName, radioBtnGroupName }, index: number) => {
        return (
          <Fragment key={index}>
            {index > 0 && <hr className="solid" />}
            <div className="radio-input-answer-container">
              <label htmlFor={inputName} className="radio-input-answer-label">
                {answerValue}
              </label>
              <input
                type="radio"
                className="radio-input-answer-btn"
                id={inputName}
                name={radioBtnGroupName}
                value={answerValue}
                onChange={onChangeHandler}
                checked={answerValue === defaultValue}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
